import React, { useState, useEffect, useCallback } from "react";
import API_KEY from "../../../../api/index";
import {
  Table,
  Form,
  Row,
  Col,
  Typography,
  message,
  Image,
  Space,
  Skeleton,
  Button,
} from "antd";

import CustomiseFieldsModal from "./CustomiseFieldsModal";
import { DeleteFilled } from "@ant-design/icons";
import BulkEditModal from "./BulkEditModal";
import VariantModal from "./Variant/index";
import EditableCell from "./EditableCell";
import axios from "axios";
import { getData, sendData } from "store/firebase/methods";

import { getConvertedValue, sanitizeNAN } from "utils/helpers";

const { Title } = Typography;

export const EditableContext = React.createContext(null);

const EditableRow = ({ index, ...props }) => {
  const [form] = Form.useForm();

  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  );
};

export default function NewTable({
  tableData,
  categoryId,
  category,
  showInternals,
  collectionId,
  setSaving,
  setVisibleAtrributes,
  collectionDetails,
  refreshCollection,
  setProductIds,
}) {
  const [columns, setColumns] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [data, setData] = useState([]);
  const [attributes, setAttributes] = useState(null);
  const [customAttrs, setCustomAttrs] = useState([]);
  const [showBulkEdit, setShowBulkEdit] = useState(true);
  const [internalColumns, setInternalColumns] = useState([]);
  const [variantData, setVariantData] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [categoryProducts, setCategoryProducts] = useState([]);
  const [isVariantModalVisible, setIsVariantModalVisible] = useState(false);
  const [activeProductId, setActiveProductId] = useState(null);
  const [currency, setCurrency] = useState(null);
  const [unit, setUnit] = useState(null);
  const [sizeUnit, setSizeUnit] = useState(null);
  const [collectionProductId, setCollectionProductId] = useState(null);
  const [selectedCurrency, setSelectedCurrency] = useState(null);
  const [selectedUnit, setSelectedUnit] = useState(null);
  const [selectedSizeUnit, setSelectedSizeUnit] = useState(null);
  const [isSizeChanged, changeSize] = useState(false);
  // const [globalState, setGlobalState] = useGlobal();
  // const { tableInternalColumns } = globalState;

  const [customiseColumns, setCustomiseColumns] = useState([]);
  const capitalizeFirstLetter = (
    [first = "", ...rest] = "",
    locale = navigator.language
  ) => first.toLocaleUpperCase(locale) + rest.join("");

  useEffect(() => {
    if (showInternals) {
      // console.log([...columns, ...internalColumns])
      setColumns((state) => [...state, ...internalColumns]);
    } else {
      setColumns((state) => [
        //...columns,
        ...state.filter((attr) => attr?.is_internal === false),
      ]);
    }
  }, [showInternals, internalColumns]);

  useEffect(() => {
    if (tableData && tableData?.length > 0) {
      setCategoryProducts(tableData);
    }
  }, [tableData]);

  useEffect(() => {
    const attrs = categoryProducts?.map((attr) => attr.visible_attributes);
    if (attrs?.length > 0) {
      setCustomAttrs([...new Set(attrs.flat())]);
    }
  }, [categoryProducts]);

  const updateCollection = (name, id) => {
    API_KEY.URL.patch(`${API_KEY.path.collections}/${id}`, {
      collection_name: name,
    })
      .then((response) => {
        console.log("Catalogue Updated");
      })
      .catch((err) => {});
  };

  const getTableHeader = (attribute) => {
    switch (attribute?.attributes_id?.dtype) {
      case "price":
        return attribute?.attributes_id?.is_internal === false ? (
          <span
            style={{
              color: "#828786",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-around",
              justifyItems: "center",
            }}
          >
            <select
              style={{
                background: "transparent",
                marginRight: 4,
                borderStyle: "none",
                outlineStyle: "none",
                outline: "none",
                minWidth: 100,
                padding: "0px 10px",
              }}
              // disabled={
              //   visibleAttributesColumns.length === 0
              //     ? false
              //     : !visibleAttributesColumns?.[0]?.includes(
              //         `${attribute.attributes_id?.id}`
              //       )
              // }
              onChange={(e) =>
                handleCurrencyChange(
                  e,
                  attribute.attributes_id?.name,
                  attribute.attributes_id?.id
                )
              }
            >
              <option disabled selected value>
                Currency
              </option>
              {attribute?.attributes_id?.default?.currency.map(
                (curr, index) => (
                  <option key={index} value={curr}>
                    {curr}
                  </option>
                )
              )}
            </select>
            <span>
              {" "}
              {capitalizeFirstLetter(attribute.attributes_id?.name).replace(
                "_",
                " "
              )}{" "}
            </span>
            <select
              style={{
                background: "transparent",
                marginRight: 4,
                borderStyle: "none",
                outlineStyle: "none",
                outline: "none",
                minWidth: 100,
                padding: "0px 10px",
              }}
              // disabled={
              //   visibleAttributesColumns.length === 0
              //     ? false
              //     : !visibleAttributesColumns?.[0]?.includes(
              //         `${attribute.attributes_id?.id}`
              //       )
              // }
              onChange={(e) =>
                handleUnitChange(e, attribute.attributes_id?.name)
              }
            >
              <option disabled selected value>
                Unit
              </option>
              {attribute?.attributes_id?.default?.unit.map((unit, index) => (
                <option key={index} value={unit}>
                  {unit}
                </option>
              ))}
            </select>
          </span>
        ) : (
          <span style={{ color: "#828786" }}>
            {capitalizeFirstLetter(attribute.attributes_id?.name).replace(
              "_",
              " "
            )}
          </span>
        );
      case "size":
        return attribute?.attributes_id?.is_internal === false ? (
          <span
            style={{
              color: "#828786",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-around",
              justifyItems: "center",
            }}
          >
            <span>
              {" "}
              {capitalizeFirstLetter(attribute.attributes_id?.name).replace(
                "_",
                " "
              )}{" "}
            </span>
            <select
              style={{
                background: "transparent",
                marginRight: 4,
                borderStyle: "none",
                outlineStyle: "none",
                outline: "none",
                minWidth: 100,
                padding: "0px 10px",
              }}
              // disabled={
              //   visibleAttributesColumns.length === 0
              //     ? false
              //     : !visibleAttributesColumns?.[0]?.includes(
              //         `${attribute.attributes_id?.id}`
              //       )
              // }
              onChange={(e) => {
                handleSizeUnitChange(e, attribute.attributes_id?.name);
              }}
            >
              <option disabled selected value>
                Unit
              </option>
              {attribute?.attributes_id?.default?.unit.map((unit, index) => (
                <option key={index} value={unit}>
                  {unit}
                </option>
              ))}
            </select>
          </span>
        ) : (
          <span style={{ color: "#828786" }}>
            {capitalizeFirstLetter(attribute.attributes_id?.name).replace(
              "_",
              " "
            )}
          </span>
        );
      default:
        return (
          <span style={{ color: "#828786" }}>
            {capitalizeFirstLetter(attribute.attributes_id?.name).replace(
              "_",
              " "
            )}
          </span>
        );
    }
  };

  const handleDelete = (record) => {
    // get data from firebase
    getData()
      .then((res) => {
        if (res) {
          var selectedProductsArray = res;
          //     const selectedProducts = localStorage.getItem("selectedProducts");
          // var selectedProductsArray = JSON.parse(selectedProducts);
          selectedProductsArray = selectedProductsArray.filter(
            (item) =>
              item.collection_product_id !== record.collection_product_id
          );

          setData((state) => state.filter((item) => item?.key !== record?.key));

          setSaving(true);
          API_KEY.URL.delete(
            `${API_KEY.path.collection_products}/${record?.collection_product_id}`
          )
            .then((res) => {
              if (res.status === 200) {
                setSaving(false);
                updateCollection(
                  collectionDetails.collection_name,
                  collectionId
                );
                message.success("Product deleted successfully");
                refreshCollection();
              }
            })
            .catch((err) => setSaving(false));

          sendData(selectedProductsArray);
        }
      })
      .catch((err) => {
        console.log(err);
      });

    // localStorage.setItem(
    //   "selectedProducts",
    //   JSON.stringify(selectedProductsArray)
    // );
  };

  /// creating data from api data
  useEffect(() => {
    if (categoryProducts && categoryProducts?.length > 0) {
      const newData = [];
      const newColumns = [];

      categoryProducts.forEach((item, index) => {
        let dataObj;
        let attrObj;
        let colObj;

        attrObj = item.attributes.map((attribute) => {
          // creating data object for each attribute
          if (attribute?.dtype === "price") {
            return {
              [attribute?.name]: [
                attribute?.currency,
                attribute?.values,
                attribute?.unit,
              ],
            };
          } else if (attribute?.dtype === "size") {
            return {
              [attribute?.name]: [
                attribute?.values,
                attribute?.length,
                attribute?.width,
                attribute?.height,
                attribute?.unit,
              ],
            };
          } else {
            return {
              [attribute?.name]: attribute?.values,
            };
          }
        });
        if (attrObj?.length > 0) {
          dataObj = {
            key: index,
            product_id: item?.product_id,
            image: item?.product_images?.[0]?.directus_files_id,
            ...Object.assign(...attrObj),
            productId: item?.prodId,
            collection_product_id: item?.collection_product_id,
            hasVariant: item?.hasVariant,
            numVariants: item?.numVariants,
          };
        } else {
          dataObj = {
            key: index,
            product_id: item?.product_id,
            image: item?.product_images?.[0]?.directus_files_id,
            productId: item?.prodId,
            collection_product_id: item?.collection_product_id,
            hasVariant: item?.hasVariant,
            numVariants: item?.numVariants,
            //...Object.assign(...attrObj),
          };
        }

        newData.push({ ...dataObj });
        newColumns.push(colObj);
      });

      setData(newData);
    }
  }, [categoryProducts]);
  /// ****creating coulms from api data
  useEffect(() => {
    setTableLoading(true);
    API_KEY.URL.get(`${API_KEY.path.secondaryCategory}/${categoryId}`, {
      params: {
        fields: "*,attributes.*,attributes.attributes_id.*",
      },
    })
      .then((res) => {
        const attributes = res?.data?.data?.attributes;
        setTableLoading(false);
        setAttributes(attributes);
      })
      .catch((error) => setTableLoading(false));
  }, [categoryId]);
  //******* */ // create columns from attributes state
  useEffect(() => {
    if (attributes && attributes?.length > 0) {
      var attributesColumns = attributes.map((attribute) => {
        return {
          title: getTableHeader(attribute),
          dataIndex: attribute.attributes_id?.name,
          type: attribute.attributes_id?.dtype,
          default: attribute.attributes_id?.default,
          is_internal: attribute.attributes_id?.is_internal,
          editable: true,
          id: attribute.attributes_id?.id,
          key: attribute.attributes_id?.id,
          tabname: attribute.attributes_id?.tabname,
          // visible:
          //   visibleAttributesColumns.length === 0
          //     ? true
          //     : visibleAttributesColumns?.[0]?.includes(
          //         `${attribute.attributes_id?.id}`
          //       ),
          visible: customAttrs?.includes(`${attribute.attributes_id?.id}`),
          width: 220,
          composite: attribute.attributes_id?.composite,
          // isSelected:false
          // width:220,
          // render: children=> <span style={{color:visible?'red':'green'}}>{children}</span>
        };
      });

      setInternalColumns([
        ...attributesColumns.filter(
          (attr) =>
            attr?.is_internal === true &&
            attr?.tabname !== "vendor" &&
            attr?.type === "price"
        ),
      ]);

      const staticColumns = [
        // {
        //   title: (
        //     <Checkbox
        //       style={{ color: "#828786" }}
        //       onChange={(event) => handleCheckAll(event)}
        //     >
        //       All
        //     </Checkbox>
        //   ),
        //   dataIndex: "isSelected",
        //   key: "isSelected",
        //   // fixed: "left",
        //   is_internal: false,

        //   render: (isSelected, record) => (
        //     <Checkbox
        //       checked={isSelected}
        //       onChange={(event) => handleCheck(record, event)}
        //     />
        //   ),
        // },
        {
          title: <span style={{ color: "#828786" }}> Delete</span>,
          dataIndex: "deleteId",
          key: "deleteId",
          is_internal: false,
          // fixed: "left",
          width: 70,
          fixed: "left",
          align: "center",
          render: (deleteId, record) => (
            <DeleteFilled
              style={{ color: "#B4B7B6", fontSize: "1.2rem" }}
              onClick={() => handleDelete(record)}
            />
          ),
        },
        {
          title: <span style={{ color: "#828786" }}> Product ID</span>,
          dataIndex: "product_id",
          key: "product_id",
          type: "text",
          fixed: "left",
          visible: true,
          isSelected: false,
          is_internal: false,
          width: 120,
          align: "center",
          render: (children, record) => (
            <Row justify="center">
              {record?.hasVariant ? (
                <Row justify="center">
                  <Col>
                    <Row justify="center">
                      <span style={{ color: "#1D2624" }}>{children}</span>{" "}
                    </Row>

                    <Row justify="center">
                      <Button
                        style={{ margin: 0, padding: 0 }}
                        type="link"
                        onClick={() =>
                          handleViewVariant(
                            record?.collection_product_id,
                            record
                          )
                        }
                      >
                        {`View ${record?.numVariants} variants`}
                      </Button>
                    </Row>
                  </Col>
                </Row>
              ) : (
                <span style={{ color: "#1D2624" }}>{children}</span>
              )}
            </Row>
          ),
        },
        {
          title: <span style={{ color: "#828786" }}>Image</span>,
          dataIndex: "image",
          key: "image",
          type: "image",
          width: 120,
          visible: true,
          isSelected: false,
          is_internal: false,
          fixed: "left",
          align: "center",
          // default: "none",
          // is_internal: "none",
          render: (text) => (
            <span
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignContent: "center",
              }}
            >
              <Image
                src={`${process.env.REACT_APP_DIRECTUS}assets/${text}?transforms=[["resize",{"width":100,"height":100,"fit":"contain","background":{"r":242,"g":242,"b":242}}]]`}
                alt="product"
                width="100px"
                height="100px"
                style={{ borderRadius: 8 }}
                preview={{
                  mask: (
                    <Space direction="vertical" align="center">
                      {/* <ZoomInOutlined /> */}
                      Preview
                    </Space>
                  ),
                  src: `${process.env.REACT_APP_DIRECTUS}assets/${text}?transforms=[["resize",{"width":600,"height":600,"fit":"contain","background":{"r":242,"g":242,"b":242}}]]`,
                }}
              />
            </span>
          ),
        },
      ];

      setVisibleAtrributes((state) => [...state, ...attributesColumns]);

      setColumns([
        ...staticColumns,
        ...attributesColumns.filter(
          (attr) => attr?.is_internal === false && attr?.visible === true
        ),
      ]);
    }
  }, [attributes, customAttrs]);

  const updateSizeUnit = (unit, length, width, height) => {
    getData()
      .then((res) => {
        if (res) {
          const selectedProductsArray = res;

          // const selctedProducts = localStorage.getItem("selectedProducts");
          // const selectedProductsArray = JSON.parse(selctedProducts);
          let attributesObj = [];
          for (let index = 0; index < selectedProductsArray.length; index++) {
            const product = selectedProductsArray[index];
            if (product.secondary_category.id === categoryId) {
              for (let index = 0; index < product.attributes.length; index++) {
                const attribute = product.attributes[index];

                if (
                  attribute?.dtype === "size" &&
                  attribute?.is_internal === false
                ) {
                  let obj = {
                    id: attribute.id,
                    attribute_id: attribute.attribute_id,
                    composite: {
                      // currency: currency ? currency : attribute.currency,
                      length: sanitizeNAN(attribute.length),
                      width: sanitizeNAN(attribute.width),
                      height: sanitizeNAN(attribute.height),
                      unit: unit ? unit : attribute.unit,
                    },
                    collection_product_id: product?.collection_product_id,
                  };
                  attributesObj.push(obj);
                }
              }
            }
          }

          for (let i = 0; i < selectedProductsArray.length; i++) {
            const product = selectedProductsArray[i];
            if (product.secondary_category.id === categoryId) {
              product.attributes = product.attributes.map((attr) => {
                if (attr.dtype === "price" && attr.is_internal === false) {
                  return {
                    ...attr,
                    currency: currency ? currency : attr.currency,
                    unit: unit ? unit : attr.unit,
                  };
                }
                return attr;
              });
            }
          }

          // console.log(selectedProductsArray,'changed')

          for (let index = 0; index < attributesObj.length; index++) {
            const attributesValues = attributesObj[index];

            setSaving(true);
            API_KEY.URL.patch(
              `${API_KEY.path.attribute_values}/${attributesValues?.id}`,
              attributesValues
            )
              .then((res) => {
                setSaving(false);
              })
              .catch((err) => {
                setSaving(false);
              });
          }
          localStorage.setItem(
            "selectedProducts",
            JSON.stringify(selectedProductsArray)
          );
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const updateCurrencyOrUnit = (currency, unit) => {
    getData()
      .then((res) => {
        if (res) {
          const selectedProductsArray = res;

          // const selctedProducts = localStorage.getItem("selectedProducts");
          // const selectedProductsArray = JSON.parse(selctedProducts);
          let attributesObj = [];
          for (let index = 0; index < selectedProductsArray.length; index++) {
            const product = selectedProductsArray[index];
            if (product.secondary_category.id === categoryId) {
              for (let index = 0; index < product.attributes.length; index++) {
                const attribute = product.attributes[index];

                if (
                  attribute?.dtype === "price" &&
                  attribute?.is_internal === false
                ) {
                  let obj = {
                    id: attribute.id,
                    attribute_id: attribute.attribute_id,
                    composite: {
                      currency: currency ? currency : attribute.currency,
                      unit: unit ? unit : attribute.unit,
                    },
                    collection_product_id: product?.collection_product_id,
                  };
                  attributesObj.push(obj);
                }
              }
            }
          }

          for (let i = 0; i < selectedProductsArray.length; i++) {
            const product = selectedProductsArray[i];
            if (product.secondary_category.id === categoryId) {
              product.attributes = product.attributes.map((attr) => {
                if (attr.dtype === "price" && attr.is_internal === false) {
                  return {
                    ...attr,
                    currency: currency ? currency : attr.currency,
                    unit: unit ? unit : attr.unit,
                  };
                }
                return attr;
              });
            }
          }

          // console.log(selectedProductsArray,'changed')

          for (let index = 0; index < attributesObj.length; index++) {
            const attributesValues = attributesObj[index];

            setSaving(true);
            API_KEY.URL.patch(
              `${API_KEY.path.attribute_values}/${attributesValues?.id}`,
              attributesValues
            )
              .then((res) => {
                setSaving(false);
              })
              .catch((err) => {
                setSaving(false);
              });
          }
          localStorage.setItem(
            "selectedProducts",
            JSON.stringify(selectedProductsArray)
          );
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    if (selectedCurrency) {
      updateCurrencyOrUnit(selectedCurrency, selectedUnit);
    }
  }, [selectedCurrency, selectedUnit]);

  useEffect(() => {
    if (selectedSizeUnit) {
      updateSizeUnit(selectedSizeUnit);
    }
  }, [selectedSizeUnit]);

  const handleCurrencyChange = (event, title, attributeId) => {
    setSelectedCurrency((state) => event.target.value);
    updateCurrencyOrUnit(event.target.value, selectedUnit);

    setData((state) =>
      state.map((item) => {
        item[title]?.length > 0
          ? (item[title][0] = event?.target?.value)
          : (item[title] = [event?.target?.value]);
        return item;
      })
    );
  };

  const handleSizeUnitChange = (event, title) => {
    // setSelectedSizeUnit((state) => event.target.value);
    // updateCurrencyOrUnit(selectedCurrency, event.target.value);
    setData((state) =>
      state.map((item) => {
        if (item[title]?.length > 0) {
          let oldUnit = item[title]?.[4] || "";
          let row = item[title].splice(4);
          let hasValues = item[title]
            .filter((item, index) => {
              return index !== 0 && index !== 4;
            })
            .filter(Boolean);
          let newUnit = event?.target?.value;
          if (hasValues && oldUnit && oldUnit !== newUnit) {
            const length = getConvertedValue(item[title]?.[1], newUnit);
            const width = getConvertedValue(item[title]?.[2], newUnit);
            const height = getConvertedValue(item[title]?.[3], newUnit);
            item[title] = [
              `${[length, width, height].filter(Boolean).join("x")} ${
                newUnit || ""
              }`,
              length,
              width,
              height,
              newUnit,
            ];
          } else {
            if (newUnit) {
              item[title][4] = newUnit;
            }
          }
        } else {
          item[title] = [null, null, null, null, event?.target?.value];
        }
        console.log("Logging updated item: ", item[title]);
        return item;
      })
    );
    changeSize(true);
  };

  const handleUnitChange = (event, title) => {
    setSelectedUnit((state) => event.target.value);
    // updateCurrencyOrUnit(selectedCurrency, event.target.value);

    setData((state) =>
      state.map((item) => {
        item[title]?.length > 0
          ? (item[title][2] = event?.target?.value)
          : (item[title] = [null, null, event?.target?.value]);
        return item;
      })
    );
  };

  const columnsData = React.useMemo(() => columns, [columns]);
  const components = {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
  };
  const handleSave = (row) => {
    const newData = [...data];
    const index = newData.findIndex((item) => row.key === item.key);
    const item = newData[index];
    newData.splice(index, 1, { ...item, ...row });

    updateCollection(collectionDetails.collection_name, collectionId);
    // this.setState({
    //   dataSource: newData,
    // });
    setData((state) => newData);
  };
  const newColumns = columnsData.map((col) => {
    if (!col.editable) {
      return col;
    }

    return {
      ...col,
      onCell: (record) => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        type: col?.type,
        visible: col?.visible,
        attributeId: col?.id,
        // initialValue:col?.values,
        defaultValues: col?.default,
        collectionid: collectionId,
        collectionDetails: collectionDetails,
        composite: col?.composite,
        isInternal: col?.is_internal,
        categoryProducts: categoryProducts,
        setCategoryProducts: setCategoryProducts,
        data: data,
        setSaving: setSaving,
        handleSave: handleSave,
        changeSize: changeSize,
        isSizeChanged: isSizeChanged,
      }),
    };
  });

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleChange = (e, col) => {
    // col.visible = e.target.checked;

    setCustomiseColumns((state) =>
      state.map((item) => {
        if (item?.dataIndex === col?.dataIndex) {
          return {
            ...item,
            visible: e.target.checked,
            //title: col?.type === "price" && !e.target.checked ? col?.dataIndex : col?.title,
          };
        }
        return item;
      })
    );
  };
  const handleDone = (category) => {
    const visibleColumns = customiseColumns.filter(
      (col) => col?.visible === true
    );

    const visibleAttributes = visibleColumns
      .filter((attr) => attr?.id)
      .map((attr) => attr?.id);

    const productsKeys = categoryProducts.map(
      (item) => item?.collection_product_id
    );
    setVisibleAtrributes((state) => [...state, ...visibleColumns]);

    const payload = {
      keys: productsKeys,
      data: {
        visible_attributes: visibleAttributes.join(","),
      },
    };

    setSaving(true);

    API_KEY.URL.patch(API_KEY.path.collection_products, payload)
      .then((res) => {
        setSaving(false);
        refreshCollection();
      })
      .catch((err) => setSaving(false));

    handleOk();
    setColumns(customiseColumns);
  };

  const showVariantModal = () => {
    setIsVariantModalVisible(true);
    setCurrency(null);
    setUnit(null);
    setSizeUnit(null);
  };

  const handleOkVariant = () => {
    setIsVariantModalVisible(false);
  };

  const handleCancelVariant = () => {
    setIsVariantModalVisible(false);
  };

  const handleViewVariant = (id, record) => {
    setActiveProductId(record?.product_id);

    setCollectionProductId(id);
    setVariantData([]);
    API_KEY.URL.get(`${API_KEY.path.variantModal}/${id}`)
      .then((res) => {
        setVariantData(res?.data?.result?.variants);
        showVariantModal();
      })
      .catch((err) => {
        console.log(err, "err");
      });
  };
  return (
    <div>
      <VariantModal
        isVariantModalVisible={isVariantModalVisible}
        setIsVariantModalVisible={setIsVariantModalVisible}
        handleOkVariant={handleOkVariant}
        handleCancelVariant={handleCancelVariant}
        variantData={variantData}
        activeProductId={activeProductId}
        unit={unit}
        sizeUnit={sizeUnit}
        setUnit={setUnit}
        setSizeUnit={setSizeUnit}
        currency={currency}
        setCurrency={setCurrency}
        collectionProductId={collectionProductId}
        customAttrs={customAttrs}
      />

      <CustomiseFieldsModal
        isModalVisible={isModalVisible}
        handleOk={handleOk}
        handleCancel={handleCancel}
        customiseColumns={customiseColumns}
        handleChange={handleChange}
        handleDone={handleDone}
        category={category}
      />
      <BulkEditModal
        showBulkEdit={showBulkEdit}
        setShowBulkEdit={setShowBulkEdit}
        tabName={category?.name}
      />
      <Row align="middle">
        <Col span={24}>
          <Row>
            <Col>
              <Title style={{ fontFamily: "Gilroy", margin: 0 }} level={4}>
                {category?.name} ({category?.values?.length})
              </Title>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row style={{ marginTop: "1.3rem" }}>
        <Col span={24}>
          {tableLoading ? (
            <Skeleton active />
          ) : (
            <Table
              pagination={false}
              size="small"
              bordered
              components={components}
              dataSource={data}
              columns={newColumns}
              scroll={{ x: "max-content" }}
            />
          )}
        </Col>
      </Row>
    </div>
  );
}
